export default [
  {
    path: "/",
    name: "Homepage",
    component: () => import("@/modules/public/pages/HomePage.vue"),
    meta: {
      breadcrumb: [{label: "Homepage"}],
      requireLogin: false,
      layout: 'App',
      module: 'Public'
    },
  },

  {
    path: "/:pathMatch(.*)",
    name: "NotFound",
    component: () => import("@/layout/NotFound.vue"),
    meta: {
      requireLogin: false,
      layout: 'NotFound'
    },
  },
]
